import { render } from "./TenanciesDetail.vue?vue&type=template&id=36d55e3c&ts=true"
import script from "./TenanciesDetail.vue?vue&type=script&lang=ts"
export * from "./TenanciesDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__